/**
 * Range select box item state.
 */
export enum SelectRangeItemState {
    NONE,
    INCLUDED,
    EXCLUDED
}

export const MAX_DISPLAYED_RANGE_SEARCH_ITEMS: number = 150
